import axios from 'axios';
import resolve from './resolve';
import { URL_SERVER } from '../utils/const';

export async function returnTasks(): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/m_0001/calls/resourceData/tasks`, {
			withCredentials: true,
		})
	);
}

export async function setTaskGetter(
	hello_text: string,
	ls_message: string,
	meter_message: string,
	info_message: string,
	recording_calls: boolean,
	gmt: string,
	input_type: string,
	ls_message_voice: string,
	ls_message_dtmf: string,
	ls_message_voice_dtmf: string,
	meter_message_voice: string,
	meter_message_dtmf: string,
	meter_message_voice_dtmf: string,
	voice: string,
	good_buy_text: string,
	recognizeOn: boolean,
	scheduleType: string,
	getterStart: string | undefined,
	getterEnd: string | undefined,
	schedule_text: string | undefined,
	caching: boolean,
	lowerReadings: boolean,
	bitrix_integration: boolean,
	useDoubleValues: boolean,
	use_service_filter: boolean,
	voice_meter_number: boolean,
	service_filter_list: string
): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/m_0001/getter_db`, {
			withCredentials: true,
			params: {
				hello_text: hello_text,
				ls_message: ls_message,
				meter_message: meter_message,
				info_message: info_message,
				recording_calls: recording_calls,
				gmt: gmt,
				input_type: input_type,
				ls_message_voice: ls_message_voice,
				ls_message_dtmf: ls_message_dtmf,
				ls_message_voice_dtmf: ls_message_voice_dtmf,
				meter_message_voice: meter_message_voice,
				meter_message_dtmf: meter_message_dtmf,
				meter_message_voice_dtmf: meter_message_voice_dtmf,
				voice: voice,
				good_buy_text: good_buy_text,
				recognizeOn: recognizeOn,
				scheduleType: scheduleType,
				getterStart: getterStart,
				getterEnd: getterEnd,
				schedule_text: schedule_text,
				caching: caching,
				lowerReadings: lowerReadings,
				bitrix_integration: bitrix_integration,
				useDoubleValues: useDoubleValues,
				use_service_filter: use_service_filter,
				voice_meter_number: voice_meter_number,
				service_filter_list: service_filter_list
			},
		})
	);
}

export async function offTaskGetter(
	hello_text: string,
	ls_message: string,
	meter_message: string,
	info_message: string,
	recording_calls: boolean,
	gmt: string,
	input_type: string,
	ls_message_voice: string,
	ls_message_dtmf: string,
	ls_message_voice_dtmf: string,
	meter_message_voice: string,
	meter_message_dtmf: string,
	meter_message_voice_dtmf: string,
	voice: string,
	good_buy_text: string,
	recognizeOn: boolean,
	scheduleType: string,
	getterStart: string | undefined,
	getterEnd: string | undefined,
	schedule_text: string | undefined,
	caching: boolean,
	lowerReadings: boolean,
	bitrix_integration: boolean,
	useDoubleValues: boolean,
	use_service_filter: boolean,
	voice_meter_number: boolean,
	service_filter_list: string
): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/m_0001/getter_off_db`, {
			withCredentials: true,
			params: {
				hello_text: hello_text,
				ls_message: ls_message,
				meter_message: meter_message,
				info_message: info_message,
				recording_calls: recording_calls,
				gmt: gmt,
				input_type: input_type,
				ls_message_voice: ls_message_voice,
				ls_message_dtmf: ls_message_dtmf,
				ls_message_voice_dtmf: ls_message_voice_dtmf,
				meter_message_voice: meter_message_voice,
				meter_message_dtmf: meter_message_dtmf,
				meter_message_voice_dtmf: meter_message_voice_dtmf,
				voice: voice,
				good_buy_text: good_buy_text,
				recognizeOn: recognizeOn,
				scheduleType: scheduleType,
				getterStart: getterStart,
				getterEnd: getterEnd,
				schedule_text: schedule_text,
				caching: caching,
				lowerReadings: lowerReadings,
				bitrix_integration: bitrix_integration,
				useDoubleValues: useDoubleValues,
				use_service_filter: use_service_filter,
				voice_meter_number: voice_meter_number,
				service_filter_list: service_filter_list
			},
		})
	);
}
